import { fetcher } from '@commenda/utils';
import {
  CreateFilingDocumentData,
  FilingActionResponse,
  UpdateFilingParams,
} from './types';

export async function lockSalesTaxFiling(
  filingId: string,
  corporation_id: number
): Promise<FilingActionResponse> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings/${filingId}/lock?corporation_id=${corporation_id}`,
      {
        method: 'POST',
      }
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to approve filing',
      };
    }

    return {
      success: true,
      data: data.data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

export async function unlockSalesTaxFiling(
  filingId: string,
  corporation_id: number
): Promise<FilingActionResponse> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings/${filingId}/unlock?corporation_id=${corporation_id}`,
      {
        method: 'POST',
      }
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to unlock filing',
      };
    }

    return {
      success: true,
      data: data.data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

export async function createFilingDocument(
  filingId: string,
  corporation_id: number,
  data: CreateFilingDocumentData
): Promise<FilingActionResponse> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings/${filingId}/documents?corporation_id=${corporation_id}`,
      {
        method: 'POST',
        body: data,
      }
    );
    const responseData = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: responseData.message || 'Failed to create filing document',
      };
    }

    return {
      success: true,
      data: responseData.data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

export async function submitSalesTaxFiling(
  filingId: string,
  corporation_id: number
): Promise<FilingActionResponse> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings/${filingId}/submit?corporation_id=${corporation_id}`,
      {
        method: 'POST',
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: responseData.message || 'Failed to submit filing',
      };
    }

    return {
      success: true,
      data: responseData.data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

export async function updateSalesTaxFiling(
  filingId: string,
  corporation_id: number,
  data?: UpdateFilingParams
): Promise<FilingActionResponse> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings/${filingId}?corporation_id=${corporation_id}`,
      {
        method: 'POST',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: responseData.message || 'Failed to update filing',
      };
    }

    return {
      success: true,
      data: responseData,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
